import { Link } from '@chakra-ui/next-js';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { RedirectToAppButton } from '@/widgets/RedirectToAppButton';
import { getNavLinks } from '@/shared/constants';
import { usePageName } from '@/shared/hooks';
import { SelectAccordion } from '@/shared/ui';
import { localStorage } from '@/shared/utils';

const MobileMenuDefaultLinks: FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();
  const pageName = usePageName();
  const navLinks = getNavLinks(t);

  const isShowProducts = localStorage.getItem('isShowProducts') !== 'false';
  let currentLinks = navLinks;

  if (!isShowProducts) {
    currentLinks = navLinks.filter((item) => item.title !== t('common.footer.navigation.products'));
  }

  return (
    <>
      {currentLinks.map(({ title, items, href }) => {
        if (items) {
          return (
            <SelectAccordion
              key={title}
              list={items}
              title={title}
              onClickLink={() => onClick?.()}
            />
          );
        }
        return (
          <Link
            key={title}
            href={href!}
            onClick={() => onClick?.()}
          >
            {title}
          </Link>
        );
      })}
      <RedirectToAppButton
        buttonText={t('common.header.login')}
        dataLayer={{ data: { redirected_from: `${pageName}_mobile_menu` } }}
        display={{ base: 'flex', md: 'none' }}
        mt='lg'
        pageName='login'
        variant='link'
        w='fit-content'
      />
    </>
  );
};

export default MobileMenuDefaultLinks;
